import * as React from "react";
import { SettingsMenu as StyledSettingMenu } from "styles/Settings";
import {
  LeftOutlined,
  RightOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";

interface IProps {
  isOpen: boolean;
  onClick: () => void;
  pages: Record<string, [string, string]>;
  onSelect: (value: any) => void;
}

const SettingsMenu = ({ isOpen, onClick, pages, onSelect }: IProps) => {
  const [active, setActive] = React.useState<number | null>(0);
  const history = useHistory();
  const onSelectClick = (key: string, index: number) => {
    onSelect(key);
    setActive(index);
  };
  return (
    <StyledSettingMenu isOpen={isOpen}>
      <nav className="container">
        <div>
          {Object.entries(pages).map(([key, [route, text]], i) => (
            <div
              className={`link ${active === i ? "active" : ""}`}
              onClick={() => onSelectClick(key, i)}
            >
              <div className="arrow">
                {active === i ? <RightOutlined /> : null}
              </div>
              <Link className="link" to={route}>
                {text}
              </Link>
            </div>
          ))}
        </div>
        <div className="back-btn" onClick={() => history.push("/")}>
          <ArrowLeftOutlined />
          <span>返回首頁</span>
        </div>
      </nav>
      <div className="tab" onClick={onClick}>
        {isOpen ? <LeftOutlined /> : <RightOutlined />}
      </div>
    </StyledSettingMenu>
  );
};

export default SettingsMenu;
